import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, TOKEN_KEY } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) { setUser(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => {
      localStorage.removeItem(TOKEN_KEY);
      setUser(false);
    });
  }, []);

  const apply = useCallback((data) => {
    localStorage.setItem(TOKEN_KEY, data.access_token);
    setUser(data.user);
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    apply(data);
  }, [apply]);

  const register = useCallback(async (email, password, business_name) => {
    const { data } = await api.post("/auth/register", { email, password, business_name });
    apply(data);
  }, [apply]);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  }, []);

  const refreshBilling = useCallback((billing) => setUser((u) => (u ? { ...u, billing } : u)), []);

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, refreshBilling }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
